<template>
    <v-dialog v-model="dialog" max-width="700px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Guardar Dominio/Hosting
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-form class="mt-3">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="dominio.id_producto"
                                :items="productosDominio"
                                label="Producto"
                                item-text="nombre"
                                item-value="id"
                                clearable
                                :loading="loadingProductos"
                                @change="onProductoChange"
                            >
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.nombre }}</span>
                                </template>
                                <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>No hay productos</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="dominio.id_cliente"
                                :items="clientes"
                                label="Cliente"
                                item-text="nombre"
                                item-value="id"
                                clearable
                                :loading="loadingClientes"
                            >
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.nombre }}</span>
                                </template>
                                <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>No hay clientes</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="dominio.nombre"
                                label="Nombre"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="dominio.precio"
                                label="Precio"
                                type="number"
                                step="0.01"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="dominio.observaciones"
                                label="Observaciones"
                                rows="3"
                                outlined
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <date-select
                                v-model="dominio.fecha_alta"
                                label="Fecha Alta"
                            ></date-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <date-select
                                v-model="dominio.fecha_vencimiento"
                                label="Fecha Vencimiento"
                            ></date-select>
                        </v-col>
                    </v-row> </v-form
            ></v-card-text>
            <v-card-actions class="pt-3">
                <v-btn
                    v-if="!dominio.id"
                    :disabled="isloading"
                    color="success"
                    class="white--text"
                    @click="createServicio"
                    >Guardar</v-btn
                >
                <v-btn
                    @click="updateServicio"
                    v-else
                    :disabled="isloading"
                    color="success"
                    class="white--text"
                    >Actualizar</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ["data", "value"],
    data() {
        return {
            productosDominio: [],
            loadingProductos: false,
            clientes: [],
            loadingClientes: false,
            dialog: false,
            dominio: {
                id_servicio: null,
                id_cliente: null,
                id_producto: null,
                nombre: null,
                precio: null,
                observaciones: null,
                fecha_alta: null,
                fecha_vencimiento: null,
            },
        };
    },
    watch: {
        dialog(val) {
            this.$emit("input", val);
        },
        value(val) {
            this.dialog = val;
        },
        data(val) {
            if (val != null) {
                this.dominio = { ...this.dominio, ...val };
            } else {
                this.dominio = {
                    id_servicio: null,
                    id_cliente: null,
                    id_producto: null,
                    nombre: null,
                    precio: null,
                    observaciones: null,
                    fecha_alta: null,
                    fecha_vencimiento: null,
                };
            }
        },
    },
    created() {
        this.getProductosDominio();
        this.getClientes();
        if (this.value != null) {
            this.dialog = this.value;
        }
        if (this.data != null) {
            this.dominio = { ...this.dominio, ...this.data };
        }
    },
    methods: {
        async getProductosDominio() {
            this.loadingProductos = true;
            try {
                const res = await axios.get("api/hosting/productos-dominio");
                this.productosDominio = Array.isArray(res.data) ? res.data : [];
            } catch (ex) {
                this.productosDominio = [];
            } finally {
                this.loadingProductos = false;
            }
        },
        onProductoChange(idProducto) {
            if (!idProducto) return;
            const p = this.productosDominio.find((x) => x.id === idProducto);
            if (p) {
                this.dominio.precio = p.precio != null ? p.precio : this.dominio.precio;
                this.dominio.observaciones = p.descripcion || this.dominio.observaciones || '';
            }
        },
        async getClientes() {
            this.loadingClientes = true;
            try {
                const res = await axios.get("api/get-all-clientes-active-proyectos");
                const users = res.data?.users ?? res.data ?? [];
                this.clientes = Array.isArray(users) ? users : [];
            } catch (ex) {
                this.clientes = [];
            } finally {
                this.loadingClientes = false;
            }
        },
        payloadParaGuardar() {
            const p = { ...this.dominio };
            if (p.id_producto && !p.id_servicio) {
                p.id_servicio = 3;
            }
            return p;
        },
        async createServicio() {
            try {
                const res = await axios.post("api/hosting", this.payloadParaGuardar());
                this.$emit("saved", res.data);
                this.dialog = false;
            } catch (ex) {}
        },
        async updateServicio() {
            try {
                const res = await axios.put(
                    `api/hosting/${this.dominio.id}`,
                    this.payloadParaGuardar()
                );
                this.$emit("saved", res.data);
                this.dialog = false;
            } catch (ex) {}
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
    filters: {},
};
</script>
